import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {HeaderSearchComponent} from './components/header-search/header-search.component';
import {HeaderNotificationComponent} from './components/header-notification/header-notification.component';
import {AuthService} from '@core/services/auth.service';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  @Output() menuToggle = new EventEmitter<void>();
  ngOnInit(): void {
  }
  constructor(
    private dialog: MatDialog,
    public auth: AuthService,
  ) {}


  SetDialogWidth(): string {
    let returnWidth;
    let windowWidth = window.innerWidth;
    switch (true) {
      case windowWidth < 450: {
        returnWidth = '94vw';
        break;
      }
      case windowWidth >= 450 && windowWidth < 750: {
        returnWidth = '94vw';
        break;
      }
      default:
        returnWidth = '600px';
    }
    return returnWidth;
  }

  headerSearch(): void {
    let width = this.SetDialogWidth()
    const dialog = this.dialog.open(HeaderSearchComponent, {
      minWidth: width,
      width: width,
      minHeight: '600px',
      // maxHeight: '545px',
      // panelClass: 'overflow_visible',
      hasBackdrop: true,
      // disableClose: true
    });
  }

  SetDialogWidthNotification(): string {
    let returnWidth;
    let windowWidth = window.innerWidth;
    switch (true) {
      case windowWidth < 450: {
        returnWidth = '94vw';
        break;
      }
      case windowWidth >= 450 && windowWidth < 750: {
        returnWidth = '94vw';
        break;
      }
      default:
        returnWidth = '500px';
    }
    return returnWidth;
  }

  headerNotification(): void {
    let width = this.SetDialogWidthNotification()
    const dialog = this.dialog.open(HeaderNotificationComponent, {
      minWidth: width,
      width: width,
      minHeight: '600px',
      maxHeight: '600px',
      // panelClass: 'overflow_visible',
      hasBackdrop: true,
      // disableClose: true,
      position: {
        top: '50px',      // adjust as needed
        right: '60px'     // adjust as needed
      }
    });
  }
  toggleMenu() {
    this.menuToggle.emit(); // notify parent (LayoutComponent)
  }

  logout() {
    this.auth.logout();
  }


}
